<mat-card class="vct-attach-card">
  <mat-card-header>
    <mat-card-title class="vct-attach-title">
      <mat-icon class="vct-attach-title-icon">settings_input_hdmi</mat-icon>
      Connection Template
    </mat-card-title>
    <mat-card-subtitle *ngIf="contextLabel">{{ contextLabel }}</mat-card-subtitle>
    <mat-card-subtitle *ngIf="!contextLabel">
      Pick an existing connection template, view its settings, or create a new one in place.
      Pick "— None —" to fall back to the global server defaults.
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <!-- Loading list -->
    <div *ngIf="loadingList" class="vct-attach-loading">
      <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
      <span>Loading templates…</span>
    </div>

    <!-- Load error -->
    <div *ngIf="loadError" class="vct-attach-error">
      <mat-icon color="warn">error_outline</mat-icon>
      <span>{{ loadError }}</span>
      <button mat-button color="primary" (click)="loadTemplates()">
        <mat-icon>refresh</mat-icon> Retry
      </button>
    </div>

    <!-- Picker — autocomplete with View / New icons embedded as field suffix -->
    <mat-form-field *ngIf="!loadingList && !loadError"
                    appearance="outline" class="vct-attach-field">
      <mat-label>Attached template</mat-label>
      <!-- autocomplete="off" suppresses the browser's native autocomplete dropdown. -->
      <input matInput
             type="text"
             autocomplete="off"
             [formControl]="pickerControl"
             [matAutocomplete]="auto"
             placeholder="Type to filter or pick…">

      <!-- View icon — only enabled when a template is currently attached. -->
      <button matSuffix mat-icon-button
              [disabled]="disabled || !currentId"
              (click)="openViewDrawer(); $event.stopPropagation()"
              matTooltip="View attached template settings"
              aria-label="View attached template settings">
        <mat-icon>visibility</mat-icon>
      </button>

      <!-- New icon — always enabled (creates and attaches a fresh template). -->
      <button matSuffix mat-icon-button
              [disabled]="disabled"
              (click)="openCreatePanel(); $event.stopPropagation()"
              matTooltip="Create a new template and attach it"
              aria-label="Create a new template">
        <mat-icon>add</mat-icon>
      </button>

      <mat-autocomplete #auto="matAutocomplete"
                        [displayWith]="displayTemplate"
                        (optionSelected)="onOptionSelected($event.option.value)">
        <!-- Sentinel "— None —" entry — picking it detaches the current template. -->
        <mat-option [value]="NONE_SENTINEL" class="vct-attach-none-option">
          <mat-icon class="vct-attach-none-icon">link_off</mat-icon>
          — None (use global defaults) —
        </mat-option>
        <mat-option *ngFor="let t of (filteredTemplates$ | async)" [value]="t">
          {{ t.templateName }}
          <span class="vct-attach-protocol-chip">{{ t.protocol === 'Rdp' ? 'RDP' : 'VNC' }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Empty hint when nothing attached -->
    <div *ngIf="!loadingList && !loadError && !currentId" class="vct-attach-empty">
      <mat-icon>info</mat-icon>
      <span>No template attached, restrictive defaults will be used.</span>
    </div>

  </mat-card-content>
</mat-card>

<!-- ── Read-only details drawer (right-aligned overlay) ──
     Implemented as a plain fixed-position scrim + aside instead of a
     <mat-sidenav-container>. The Material drawer wrapper paints an opaque
     surface across the whole viewport even when only one slot is used,
     which made the parent page appear blanked-out. -->
<ng-container *ngIf="showDetailDrawer">
  <div class="vct-drawer-scrim" (click)="closeDrawer()" aria-hidden="true"></div>
  <aside class="vct-drawer" role="dialog" aria-modal="true" aria-labelledby="vct-detail-drawer-title">
    <div class="vct-drawer-header">
      <div class="vct-drawer-title" id="vct-detail-drawer-title">
        <mat-icon>settings_input_hdmi</mat-icon>
        <span>Template Details</span>
      </div>
      <button mat-icon-button (click)="closeDrawer()" matTooltip="Close" aria-label="Close drawer">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div class="vct-drawer-body">
      <div *ngIf="isLoadingDetail" class="vct-drawer-loading">
        <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
        <span>Loading template details…</span>
      </div>
      <app-view-vm-connection-template-details
        *ngIf="!isLoadingDetail && viewedDetail"
        [detail]="viewedDetail">
      </app-view-vm-connection-template-details>
    </div>
  </aside>
</ng-container>

<!-- ── Create panel — also rendered as a right-side drawer (handled by the panel itself) ── -->
<app-vm-connection-template-create-panel
  *ngIf="showCreatePanel"
  [contextLabel]="contextLabel"
  (cancelled)="closeCreatePanel()"
  (created)="onTemplateCreated($event)"
  (pickExisting)="onPickExistingDuplicate($event)">
</app-vm-connection-template-create-panel>
